<template>
  <div>
    <slot name="group:title"></slot>
    <div class="grid col-span-2 gap-4 sm:grid-cols-2">
      <field-has-insurance
        :controls="controls"
        :value="controls.has_insurance"
        @input:field="onInput($event, 'has_insurance')"
      ></field-has-insurance>
      <slot name="insert:insurance-ocr"></slot>
      <component
        v-for="c in components"
        :key="c.key"
        :is="c.name"
        :controls="controls"
        :value="c.value"
        :http-errors="c.errors"
        @input:field="onInput($event, c.key)"
      ></component>
    </div>
  </div>
</template>

<script>
import FieldHasInsurance from "@/components/Field/Insurance/HasInsurance";
import FieldInsurance from "@/components/Field/Insurance/Insurance";
import FieldOtherInsurance from "@/components/Field/Insurance/OtherInsurance";
import FieldPlanName from "@/components/Field/Insurance/PlanName";
import FieldGroupNumber from "@/components/Field/Insurance/GroupNumber";
import FieldInsurancePhoneNumber from "@/components/Field/Insurance/InsurancePhoneNumber";
import FieldMemberIdNumber from "@/components/Field/Insurance/MemberIdNumber";
import FieldHomeZipcode from "@/components/Field/Insurance/HomeZipcode";
import FieldEmployerName from "@/components/Field/Insurance/EmployerName";
import FieldIsPolicyHolder from "@/components/Field/Insurance/IsPolicyHolder";
import FieldPolicyHoldersFirstname from "@/components/Field/Insurance/PolicyHoldersFirstname";
import FieldPolicyHoldersLastname from "@/components/Field/Insurance/PolicyHoldersLastname";
import FieldPolicyHoldersDob from "@/components/Field/Insurance/PolicyHoldersDob";
const FIELDS = [
  "insurance",
  "other_insurance",
  "plan_name",
  "group_number",
  "insurance_phone_number",
  "member_id_number",
  "employer_name",
  "home_zipcode",
  "is_policy_holder",
  "policy_holders_firstname",
  "policy_holders_lastname",
  "policy_holders_dob",
];

export default {
  components: {
    FieldHasInsurance,
    FieldInsurance,
    FieldOtherInsurance,
    FieldPlanName,
    FieldGroupNumber,
    FieldInsurancePhoneNumber,
    FieldHomeZipcode,
    FieldEmployerName,
    FieldMemberIdNumber,
    FieldIsPolicyHolder,
    FieldPolicyHoldersFirstname,
    FieldPolicyHoldersLastname,
    FieldPolicyHoldersDob,
  },
  props: ["controls", "errors"],
  computed: {
    hasInsurance() {
      return this.controls.has_insurance;
    },
    isRequired() {
      return this.$store.getters.insuranceFieldsIsRequired;
    },
    isOther() {
      return this.controls?.insurance?.id === "other";
    },
    isSingle() {
      return this.$store.getters.isSingleLocation;
    },
    isReverse() {
      return this.$store.getters.flowType === "reverse";
    },
    fields() {
      const companyId = this.$store.state.config?.companyId?.toString();
      const mintCompanyId = "2";

      if (this.hasInsurance) {
        if (!this.isOther) {
          if (companyId === mintCompanyId) {
            return FIELDS.filter(
              (el) => !["other_insurance", "home_zipcode"].includes(el)
            );
          }
          return FIELDS.filter((el) => !["other_insurance"].includes(el));
        } else {
          if (companyId === mintCompanyId) {
            return FIELDS.filter((el) => !["home_zipcode"].includes(el));
          }
          return FIELDS;
        }
      }

      if (!this.hasInsurance) return [];

      return FIELDS;
    },
    components() {
      return this.fields.map((el) => ({
        key: el,
        name: "field-" + el.replace(/_/g, "-"),
        value: this.controls[el],
        errors: this.errors?.validation?.[`input.insurance.${el}`],
      }));
    },
  },
  methods: {
    onInput(value, key) {
      this.$emit("input:group", { value, key });
    },
  },
};
</script>
